var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[_c('b-col',{staticClass:"w-full"},[_c('FullCalendar',{attrs:{"options":_vm.calendarOptions,"id":"calendario-x"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }